<template>
  <ion-page>
    <ion-content>
      <p style="text-align: center;" v-if="!store.state.reviews.length && !notReviewedAndFinishedTasks(store.state.tasks).length">
        Bitte erledige Aufgaben, um Reviews erstellen zu können!
      </p>
      <!-- button zum erstellen -->
      <div style="text-align: center" v-if="notReviewedAndFinishedTasks(store.state.tasks).length">
      <ion-button @click="createReview(selected)" :disabled="selected.length===0">Review aus Auswahl erstellen</ion-button>
        <br/>
      <IonNote v-if="!selected.length">Bitte wählen Sie Tasks für ein Review aus</IonNote>
      <IonNote v-if="selected.length">{{ selected.length }} Aufgaben gewählt</IonNote>
      </div>
      <!-- liste geschlossener, unrevieweter tasks-->
      <IonList>
        <ion-list-header v-if="notReviewedAndFinishedTasks(store.state.tasks).length">Abgeschlossene Aufgaben</ion-list-header>

          <TaskItem v-for="task in notReviewedAndFinishedTasks(store.state.tasks)"  v-bind:key="task.id" :task="task" :read-only="true" :show-review="true" @createReview="createReview([task.id])" @selected="selected.push(task.id)" @unselected="selected = selected.filter(e => e!=task.id)"/>

        <ion-list-header v-if="store.state.reviews.length" style="margin-top:30px;">Bereits erstellte Reviews</ion-list-header>
        <ion-item @click="editReviewReview(review.id)" v-for="review in store.state.reviews" :key="review.id">
          <ion-label>
            <p>vom {{formatReviewDate(review.created)}}:</p>
            <h3>{{review.description}}</h3>
            <p>{{ tasks(review)}}</p>
          </ion-label>
        </ion-item>
      </IonList>
      <!-- liste der reviews absteigend nach erstellungsdatum sortiert-->
    </ion-content>
  </ion-page>
</template>

<script lang="ts">
import {IonPage, IonContent, IonList,IonNote, IonItem, IonLabel,IonButton, IonListHeader} from '@ionic/vue'
import TaskItem from "@/components/TaskItem.vue";
import {defineComponent} from "vue";
import {useStore} from "@/store/store";
import {useI18n} from "vue-i18n";
import firebase from "firebase";
import {Review, Task, TaskState, TaskUtils} from "@/store/state";
import {useRouter} from "vue-router";
export default defineComponent({
  components: {
    IonListHeader,
    IonItem,
    IonLabel,
    TaskItem,
    IonPage,
    IonContent,
    IonList,IonNote, IonButton
  },
  name: "Reviews",
  computed:{

  },
  data(){
    const selected: string[] = []
    return {
      selected
    }
  },
  filters:{

  },
  methods:{
    formatReviewDate(v: any){
      const d = TaskUtils.asDate(v)
      return d.toLocaleDateString('de-de');
    },
    notReviewedAndFinishedTasks(tasks: Task[]): Task[]{
      console.log("tasks",tasks);
      return tasks.filter((t: Task) => t.state==TaskState.Done && !t.reviews.length )
    },
    createReview(tasks: string[]){
      this.router.push({name: 'NewReview',params:{tasks:tasks.join(',')}})
    },
    editReviewReview(review: string){
      this.router.push({name: 'EditReview',params:{reviewId:review}})
    },
    tasks(review: Review){
      const tasks: string = this.store.state.tasks.filter((t: Task) => review.tasks.includes(t.id)).map((t: Task)=>t.name).join(', ');
      if(tasks) return 'Aufgaben: '+tasks;
      return 'Keine verknüpften Aufgaben'
    }

  },
  setup(){
    const store = useStore()
    const router = useRouter()
    const t = useI18n()
    return {
      router,
      store,
      t
    }
  }
})
</script>

<style scoped>

</style>